import { render } from "./SuggestionPopup.vue?vue&type=template&id=0c4008b4&scoped=true&lang=pug"
import script from "./SuggestionPopup.vue?vue&type=script&lang=js"
export * from "./SuggestionPopup.vue?vue&type=script&lang=js"

import "./SuggestionPopup.vue?vue&type=style&index=0&id=0c4008b4&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c4008b4"]])

export default __exports__